<template>
  <v-row justify="center" no-gutters>
    <v-col cols="12" xs="12" md="8">
      <v-container>
        <div class="home">
          <div class="customers">
            <v-card>
              <v-toolbar
                color="primary"
                dark
                flat
              >
                <v-toolbar-title>Choose a Customer</v-toolbar-title>
              </v-toolbar>
              <LoadingBarComponent v-show="customersLoading" loading-text="Loading Customers"/>
              <v-alert v-if="customersError !== null" text dense type="error">
                {{ customersError }}
              </v-alert>
              <CustomerList
                v-if="customersData !== null && customersData.length > 1"
                :on-click-customer="setCurrentCustomer"
                :customers="customersData"/>
            </v-card>
          </div>
        </div>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
// @ is an alias to /src
import CustomerList from '@/components/CustomerList'
import LoadingBarComponent from '../components/LoadingBarComponent'

export default {
  name: 'home',
  components: {
    CustomerList,
    LoadingBarComponent
  },
  computed: {
    customersData: function () {
      return this.$store.state.customers.data
    },
    customersError: function () {
      return this.$store.state.customers.error
    },
    customersLoading: function () {
      return this.$store.state.customers.error === null && this.$store.state.customers.data === null
    }
  },
  methods: {
    setCurrentCustomer: function (customer) {
      this.$store.commit('customer/setCurrentCustomer', { data: customer, error: null })
      this.$router.push({ name: 'customer', params: { customerId: customer.id } })
    }
  },
  created: function () {
    let self = this
    this.$store.dispatch('fetchCustomers').then(function () {
      if (self.customersData.length === 1) {
        self.$store.commit('customer/setCurrentCustomerById', self.customersData[0].id)
        self.$router.push({ name: 'customer', params: { customerId: self.customersData[0].id } })
      }
    })
  }

}
</script>
<style scoped>

</style>
